import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Select from "react-select";

import Cookies from "js-cookie";

import {
  availableActionByChapterId,
  menuChapter,
  saveChapter,
} from "../../../redux/roleManagementReducer/actionsRoleManagement";

import RoleManagementItem from "./roleManagementItem/roleManagementItem";
import RoleManagementModal from "./roleManagementModal/roleManagementModal";
import NotificationWindow from "../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import styles from "./roleManagementComponent.module.css";

const RoleManagementComponent = () => {
  const dispatch = useDispatch();

  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      border: "1px solid #BC865399",
      borderRadius: "6px",
      boxShadow: state.isFocused ? "0 0 0 .25rem #BC865380" : "",
      fontFamily: "RobotoRegular",
      fontSize: "16px",
      lineHeight: "21px",
      letterSpacing: "0px",
      textAlign: "left",
      color: "#233E5A",
      padding: "4px 0",
      "&:hover": {
        border: "1px solid #BC865399",
      },
    }),
    input: (baseStyles) => ({
      ...baseStyles,
      fontFamily: "RobotoRegular",
      fontSize: "16px",
      lineHeight: "21px",
      letterSpacing: "0px",
      textAlign: "left",
      color: "#233E5A",
    }),
    placeholder: (baseStyles) => ({
      ...baseStyles,
      color: "#BC865380",
    }),
    dropdownIndicator: (baseStyles) => ({
      ...baseStyles,
      color: "#BC865399",
      "&:hover": {
        color: "#BC865399",
        cursor: "pointer",
      },
    }),
    indicatorSeparator: (baseStyles) => ({
      ...baseStyles,
      backgroundColor: "#BC865399",
    }),
    noOptionsMessage: (baseStyles) => ({
      ...baseStyles,
      color: "#BC865380",
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      fontFamily: "RobotoRegular",
      fontSize: "16px",
      lineHeight: "21px",
      letterSpacing: "0px",
      textAlign: "left",
      backgroundColor: state.isSelected ? "#BC8653" : "",
      color: state.isSelected ? "#F4F7FA" : "#233E5A",
      "&:hover": {
        color: "#F4F7FA",
        backgroundColor: "#BC865380",
        cursor: "pointer",
      },
    }),
  };

  const userId = Cookies.get("userId");

  const { allRoles } = useSelector((state) => state.dictionaryReducer);
  const { menuChapters, chaptersByRole } = useSelector((state) => state.roleManagementReducer);

  const [selectedRole, setSelectedRole] = useState();
  const [itemsData, setItemsData] = useState(menuChapters);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [chapterPrivId, setChapterPrivId] = useState();

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
  };

  const handleItemUpdate = (updatedItem, value) => {
    const data = {
      roleid: selectedRole.roleid,
      chapterId: updatedItem.id,
      privValue: value,
      privUserId: Number(userId),
    };

    dispatch(saveChapter(data));

    checkChapter(value, updatedItem);

    setShowModal(value);
    setSelectedItem(updatedItem);
  };

  const checkChapter = (value, updatedItem) => {
    if (value) {
      const foundChapter = chaptersByRole.find((chapter) => chapter.chapterId === updatedItem.id);
      if (foundChapter?.id) {
        setChapterPrivId(foundChapter.id);
        dispatch(availableActionByChapterId(foundChapter.id));
      }
    }
  };

  const handleTextClick = (item, value) => {
    if (value) {
      checkChapter(value, item);
      setSelectedItem(item);
      setShowModal(true);
    } else {
      checkChapter(value, item);
      setSelectedItem(item);
      setShowModal(false);
    }
  };

  useEffect(() => {
    if (selectedRole) {
      dispatch(menuChapter(selectedRole.roleid));
    }
  }, [selectedRole]);

  useEffect(() => {
    setItemsData(menuChapters);
  }, [menuChapters]);

  return (
    <>
      <div className={styles["role-management-container"]}>
        <div className={styles["role-selector"]}>
          <div className={styles["role-selector-data"]}>
            <div className={styles["label"]}>Наименование</div>
            <Select
              noOptionsMessage={() => "Нет данных"}
              placeholder="Выберите роль"
              classNamePrefix="custom-select"
              styles={customStyles}
              isSearchable={true}
              value={selectedRole}
              onChange={handleRoleChange}
              options={allRoles}
            />
          </div>
        </div>
        {selectedRole && (
          <div className={styles["role-inputs-container"]}>
            {itemsData.map((item) => (
              <RoleManagementItem
                key={item.id}
                item={item}
                chaptersByRole={chaptersByRole}
                onUpdateItem={handleItemUpdate}
                handleTextClick={handleTextClick}
              />
            ))}
          </div>
        )}
      </div>
      {showModal && (
        <RoleManagementModal
          show={showModal}
          onHide={() => setShowModal(false)}
          roleName={selectedRole?.label}
          sectionName={selectedItem?.name}
          chapterId={selectedItem?.id}
          chapterPrivId={chapterPrivId}
        />
      )}
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Статус сохранения"}
        messageText={"Роль сохранена!"}
      />
    </>
  );
};

export default RoleManagementComponent;
